import { Flex, Popover } from 'antd';
import { InfoIcon } from 'lucide-react';
import React from 'react';

const ErrorStatusWithDetails = ({
  children,
  iconSize = 14,
  iconColor = '#6d6d6d',
  title = (
    <Flex align="center" gap={4}>
      <InfoIcon size={16} color="#6d6d6d" />
      <span>Error Details</span>
    </Flex>
  ),
  content = '',
  flexProps,
  popoverProps,
}) => {
  return (
    <Flex align="center" justify="center" gap={4} {...flexProps}>
      {children}
      <Popover content={content} title={title} {...popoverProps}>
        <InfoIcon size={iconSize} color={iconColor} />
      </Popover>
    </Flex>
  );
};

export default ErrorStatusWithDetails;
